import stoneService from '@services/magento/stone.service';

import { ShipmentLocation, StoneReportData } from '@stone/interfaces';
import { normalizeParams } from '@stone/searchCriteria';

export async function fetchReportsApi(params: any = {}): Promise<StoneReportData> {
  const normalised = normalizeParams(params);
  const response = await stoneService.getStoneShipmentReports(normalised);
  return response as StoneReportData;
}

export async function fetchReportHistoryApi(params: any = {}): Promise<{ items: any[]; totalCount: number }> {
  const normalised = normalizeParams(params);
  const response = await stoneService.getStoneShipments(normalised);
  return {
    items: response.items || [],
    totalCount: response.total_count || 0,
  };
}

export async function fetchPurchaseLocationsApi(params: any = {}): Promise<ShipmentLocation[]> {
  const response = await stoneService.getStoneLocations(params);
  return response.items as ShipmentLocation[];
}
